import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

export const PageTitle = ({ title, titleTemplate, children }) => {
  // Avoid passing in undefined 'titleTemplate'
  // because that resets the template.
  if (titleTemplate) {
    return (
      <Helmet titleTemplate={titleTemplate}>
        {title && <title>{title}</title>}
        {children}
      </Helmet>
    );
  } else {
    return (
      <Helmet>
        {title && <title>{title}</title>}
        {children}
      </Helmet>
    );
  }
};

PageTitle.propTypes = {
  title: PropTypes.string,
  titleTemplate: PropTypes.string,
  children: PropTypes.node,
};
